/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfGetFilterWordByIdDto } from '../models/custom-result-of-get-filter-word-by-id-dto';
import { CustomResultOfPaginatedListOfGetFilterWordsWithPaginationQueryDto } from '../models/custom-result-of-paginated-list-of-get-filter-words-with-pagination-query-dto';
import { filterWordsCreateGet } from '../fn/filter-words/filter-words-create-get';
import { FilterWordsCreateGet$Params } from '../fn/filter-words/filter-words-create-get';
import { filterWordsCreatePost } from '../fn/filter-words/filter-words-create-post';
import { FilterWordsCreatePost$Params } from '../fn/filter-words/filter-words-create-post';
import { filterWordsDelete } from '../fn/filter-words/filter-words-delete';
import { FilterWordsDelete$Params } from '../fn/filter-words/filter-words-delete';
import { filterWordsGetFilterWordsAudit } from '../fn/filter-words/filter-words-get-filter-words-audit';
import { FilterWordsGetFilterWordsAudit$Params } from '../fn/filter-words/filter-words-get-filter-words-audit';
import { filterWordsGetFilterWordsWithPagination } from '../fn/filter-words/filter-words-get-filter-words-with-pagination';
import { FilterWordsGetFilterWordsWithPagination$Params } from '../fn/filter-words/filter-words-get-filter-words-with-pagination';
import { filterWordsUpdateGet } from '../fn/filter-words/filter-words-update-get';
import { FilterWordsUpdateGet$Params } from '../fn/filter-words/filter-words-update-get';
import { filterWordsUpdatePut } from '../fn/filter-words/filter-words-update-put';
import { FilterWordsUpdatePut$Params } from '../fn/filter-words/filter-words-update-put';

@Injectable({ providedIn: 'root' })
export class FilterWordsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `filterWordsCreateGet()` */
  static readonly FilterWordsCreateGetPath = '/FilterWords/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `filterWordsCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  filterWordsCreateGet$Response(params?: FilterWordsCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return filterWordsCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `filterWordsCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  filterWordsCreateGet(params?: FilterWordsCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.filterWordsCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `filterWordsCreatePost()` */
  static readonly FilterWordsCreatePostPath = '/FilterWords/Create';

  /**
   * Create FilterWordCommand.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `filterWordsCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  filterWordsCreatePost$Response(params: FilterWordsCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return filterWordsCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create FilterWordCommand.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `filterWordsCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  filterWordsCreatePost(params: FilterWordsCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.filterWordsCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `filterWordsUpdateGet()` */
  static readonly FilterWordsUpdateGetPath = '/FilterWords/Update';

  /**
   * Get FilterWord by FilterWordId for edit.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `filterWordsUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  filterWordsUpdateGet$Response(params?: FilterWordsUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetFilterWordByIdDto>> {
    return filterWordsUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get FilterWord by FilterWordId for edit.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `filterWordsUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  filterWordsUpdateGet(params?: FilterWordsUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfGetFilterWordByIdDto> {
    return this.filterWordsUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetFilterWordByIdDto>): CustomResultOfGetFilterWordByIdDto => r.body)
    );
  }

  /** Path part for operation `filterWordsUpdatePut()` */
  static readonly FilterWordsUpdatePutPath = '/FilterWords/Update';

  /**
   * Update FilterWord.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `filterWordsUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  filterWordsUpdatePut$Response(params: FilterWordsUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return filterWordsUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update FilterWord.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `filterWordsUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  filterWordsUpdatePut(params: FilterWordsUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.filterWordsUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `filterWordsDelete()` */
  static readonly FilterWordsDeletePath = '/FilterWords/{id}';

  /**
   * Delete FilterWord.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `filterWordsDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  filterWordsDelete$Response(params: FilterWordsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return filterWordsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete FilterWord.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `filterWordsDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  filterWordsDelete(params: FilterWordsDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.filterWordsDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `filterWordsGetFilterWordsWithPagination()` */
  static readonly FilterWordsGetFilterWordsWithPaginationPath = '/FilterWords/GetFilterWordsWithPagination';

  /**
   * Get FilterWords WithPagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `filterWordsGetFilterWordsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  filterWordsGetFilterWordsWithPagination$Response(params: FilterWordsGetFilterWordsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetFilterWordsWithPaginationQueryDto>> {
    return filterWordsGetFilterWordsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get FilterWords WithPagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `filterWordsGetFilterWordsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  filterWordsGetFilterWordsWithPagination(params: FilterWordsGetFilterWordsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetFilterWordsWithPaginationQueryDto> {
    return this.filterWordsGetFilterWordsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetFilterWordsWithPaginationQueryDto>): CustomResultOfPaginatedListOfGetFilterWordsWithPaginationQueryDto => r.body)
    );
  }

  /** Path part for operation `filterWordsGetFilterWordsAudit()` */
  static readonly FilterWordsGetFilterWordsAuditPath = '/FilterWords/GetFilterWordsAudit';

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `filterWordsGetFilterWordsAudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  filterWordsGetFilterWordsAudit$Response(params: FilterWordsGetFilterWordsAudit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return filterWordsGetFilterWordsAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `filterWordsGetFilterWordsAudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  filterWordsGetFilterWordsAudit(params: FilterWordsGetFilterWordsAudit$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.filterWordsGetFilterWordsAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

}
